import React, { useState, useCallback } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import CoreValue from './components/CoreValue';
import Trends from './components/Trends';
import PainPoints from './components/PainPoints';
import Comparison from './components/Comparison';
import Insight from './components/Insight';
import Value from './components/Value';
import Solution from './components/Solution';
import Products from './components/Products';
import Process from './components/Process';
import Compliance from './components/Compliance';
import Contact from './components/Contact';
import DemoViewer from './components/DemoViewer';
import Footer from './components/Footer';

function App() {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isDemoOpen, setIsDemoOpen] = useState(false);

  const openContact = useCallback(() => setIsContactOpen(true), []);
  const closeContact = useCallback(() => setIsContactOpen(false), []);
  
  const openDemo = useCallback(() => setIsDemoOpen(true), []);
  const closeDemo = useCallback(() => setIsDemoOpen(false), []);

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <Navbar onContactClick={openContact} />
      <Hero onDemoClick={openDemo} />
      <About />
      <CoreValue />
      <div id="trends"><Trends /></div>
      <div id="pain-points"><PainPoints /></div>
      <div id="comparison"><Comparison /></div>
      <div id="insight"><Insight /></div>
      <div id="value"><Value /></div>
      <div id="solution"><Solution /></div>
      <div id="products"><Products onContactClick={openContact} /></div>
      <div id="process"><Process /></div>
      <div id="compliance"><Compliance /></div>
      
      {/* Footer */}
      <div id="footer"><Footer onContactClick={openContact} /></div>

      {/* Contact Modal */}
      <Contact isOpen={isContactOpen} onClose={closeContact} />
      
      {/* Demo Viewer Modal */}
      <DemoViewer isOpen={isDemoOpen} onClose={closeDemo} />
    </div>
  );
}

export default App;